module.exports = __webpack_public_path__ + "img/sol_cap2.92f4e821.png";